<div>
    <app-vwsa-text
        text="Choose existing customer if you are looking for an Easy Drive plan for your Volkswagen, or you can browse to see what plans are available on new or other Volkswagens.">
    </app-vwsa-text><br />
    <div class="tooltip-container" style="display:inline-flex;">
        <app-vwsa-button text="Existing Customer" (click)="onExistingCustomer()"></app-vwsa-button>
        <app-tooltip style="margin-left:10px;" tooltipText="{{contentTooltips | ContentTooltip:'Existing Customer'}}"></app-tooltip>
    </div>
    <br /><br />
    <!--<app-vwsa-button text="Just Browsing" (click)="onJustBrowsing()">
    </app-vwsa-button>-->
</div>
